import React, { useEffect, useState } from 'react';
import { Add } from '@mui/icons-material';

import {
  TextField,
  Chip,
  Box,
  Stack,
  InputAdornment,
  IconButton,
  Typography
} from '@mui/material';

interface FormikTagInputProps {
  type: string;
  name: string;
  label: any;
  fieldValue: {
    value: any;
  };
  handleChange: (event: any) => void;
}

const FormikTagInput: React.FC<FormikTagInputProps> = ({
  fieldValue,
  handleChange,
  type,
  name,
  label
}) => {
  const [chipValue, setChipValue] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [isEmail, setIsEmail] = useState<string>('');

  const handleDelete = (emailToDelete: string) => {
    if (chipValue.length > 1) {
      const updatedChipValue = chipValue.filter(
        (email) => email !== emailToDelete
      );

      setChipValue(updatedChipValue);
      handleChange(updatedChipValue);
    } else {
      handleChange('');
      setChipValue([]);
      setInputValue('');
    }
  };

  function handleAddEmail() {
    if (!inputValue) return;

    const labelText =
      typeof label === 'object' ? label?.props?.children[0] : label;
    const labelTextType = labelText.toLowerCase().split(' ');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (
      labelTextType.includes('email') &&
      !chipValue.includes(inputValue.trim())
    ) {
      if (emailRegex.test(inputValue)) {
        const updatedChipValue = [...chipValue, inputValue.trim()];
        setChipValue(updatedChipValue);
        handleChange(updatedChipValue);
        setInputValue('');
        handleChange([...chipValue, inputValue.trim()]);
      } else {
        setIsEmail('Invalid Email Address !');
      }
    } else if (!chipValue.includes(inputValue.trim())) {
      const updatedChipValue = [...chipValue, inputValue.trim()];
      setChipValue(updatedChipValue);
      handleChange(updatedChipValue);
      setInputValue('');    
    }
  }

  useEffect(() => {
    if (fieldValue?.value?.length) {
      setChipValue(fieldValue?.value);
    } else {
      setInputValue('');
      setChipValue([]);
    }
  }, [fieldValue]);

  return (
    <Box>
      <Stack spacing={1}>
        <TextField
          variant="outlined"
          name={name}
          label={label}
          value={inputValue}
          type={type}
          onChange={(e) => {
            if (e.target.value[0] !== ' ') setInputValue(e.target.value);
          }}
          sx={{ flexGrow: 1 }}
          InputProps={{
            endAdornment: (
              <>
                <InputAdornment position="end">
                  <IconButton
                    aria-label="add text as chip"
                    onClick={handleAddEmail}
                    edge="end"
                  >
                    <Add />
                  </IconButton>
                </InputAdornment>
              </>
            )
          }}
        />
        <Typography color={'#8B0000'}> {isEmail} </Typography>

        <Box>
          {chipValue.map((val) => (
            <Chip
              key={val}
              label={val}
              onDelete={() => handleDelete(val)}
              color="secondary"
            />
          ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default FormikTagInput;
